import { render } from "./matches.vue?vue&type=template&id=4143890e&scoped=true"
import script from "./matches.vue?vue&type=script&lang=js"
export * from "./matches.vue?vue&type=script&lang=js"

import "./matches.vue?vue&type=style&index=0&id=4143890e&lang=css"
import "./matches.vue?vue&type=style&index=1&id=4143890e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4143890e"]])

export default __exports__